import React from 'react'
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import me from "../../Assets/meFull.png";

const StyledHero = styled.div`
  margin-top: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  @media (max-width: 1200px) {
    flex-direction: column;
  }
`;

const StyledPortait = styled.img`
  height: 50vh;
  opacity: 0.3;
`;

const StyledDetails = styled.div`
  position: absolute;
  bottom: 20px;
  transform: translateX(340px);
  & > p {
    font-family: monospace;
    font-size: 1.2rem;
  }
  @media (max-width: 1200px) {
    display: none;
  }
`;

const StyledName = styled.h1`
  position: absolute;
  z-index: 1;
  top: 34%;
  font-size: 5rem;
  font-family: Kenoky;
  font-weight: 100;

  @media (max-width:1200px) {

    top: 20%;
    
  }

`;

const StyledActionLink = styled(Link)`
  padding: 0.5em 1em;
  margin-top: 3rem;
  border-radius: 3px;
  font-size: 1.3rem;
  font-family: monospace;
  background-color: #c9ebfe;
  transition: all .2s;
  @media (min-width: 1200px) {
    display: none;
  }

  &:hover{
  background-color: #60c5ff;

  }


`;


export default function Home() {
  return (
    <div>
      <StyledHero>
        <StyledName>Jonathan Wolf</StyledName>
        <StyledPortait src={me} alt="a photo of Jonathan Wolf" />
        <StyledDetails>
          <p>Software Engineer</p>
          <p>Applications Development</p>
        </StyledDetails>
        <StyledActionLink to="/about">ReadMe.md</StyledActionLink>
      </StyledHero>
    </div>
  )
}
